"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconChip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var Icon_1 = require("../Icon");
var Text_1 = require("../Text");
var icons_2 = require("../../icons");
var styles_1 = __importDefault(require("./styles"));
var Checkbox_1 = require("../Checkbox");
var iconsList = {
    default: icons_2.Document,
    doc: icons_2.Doc,
    'application/pdf': icons_2.PDF,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': icons_2.Xls,
};
exports.IconChip = react_1.default.memo(react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var fileName = _a.fileName, _c = _a.onRemove, onRemove = _c === void 0 ? function () { } : _c, _d = _a.fileType, fileType = _d === void 0 ? 'default' : _d, _e = _a.hideClose, hideClose = _e === void 0 ? false : _e, _f = _a.backgroundColor, backgroundColor = _f === void 0 ? false : _f, draggable = _a.draggable, chipText = _a.chipText, checked = _a.checked, checkable = _a.checkable, legendText = _a.legendText, onChange = _a.onChange, rest = __rest(_a, ["fileName", "onRemove", "fileType", "hideClose", "backgroundColor", "draggable", "chipText", "checked", "checkable", "legendText", "onChange"]);
    var classes = (0, styles_1.default)({ backgroundColor: backgroundColor, draggable: draggable, checked: checked, checkable: checkable });
    // @ts-ignore
    var iconItem = (_b = iconsList[fileType]) !== null && _b !== void 0 ? _b : icons_2.Doc;
    var icon = react_1.default.createElement(iconItem);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(core_1.Paper, __assign({ className: classes.root, role: "main", id: "".concat(fileName, "-draggable") }, { children: [draggable && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, __assign({ color: "#6798CB", isSelected: true, className: [classes.dragIcon, 'drag-handle'].join(' ') }, { children: (0, jsx_runtime_1.jsx)(icons_1.DragIndicator, { style: { color: '#6798CB' } }) }))), checkable && ((0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, __assign({ ref: ref, id: "".concat(fileName, "-checkbox"), checked: checked, onChange: onChange }, rest))), (0, jsx_runtime_1.jsx)(core_1.Box, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { children: icon }) }), (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ component: "p", fontWeight: "bold", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }, { children: chipText })), !hideClose && (
                    /* eslint-disable-next-line jsx-a11y/interactive-supports-focus */
                    (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.icon, role: "button", onClick: function () { return onRemove(); }, onKeyDown: function () { } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, __assign({ size: "small" }, { children: (0, jsx_runtime_1.jsx)(icons_2.Cancel, {}) })) })))] })), checked && legendText && ((0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ className: classes.selectedText, component: "p", weight: "semi-bold", size: "small" }, { children: legendText })))] }));
}));
